import appleIcon from "../assets/appleIcon.png";
import googlePlayIcon from "../assets/googlePlayIcon.png";

const Footer = () => {
  return (
    <section className="footer-cta">
      <h2 className="footer-cta-title">Ready to take control of your priorities?</h2>
      <p className="footer-cta-subtitle">
        Join professionals who are moving from busy work to meaningful impact with vectr42.
      </p>
      <div className="footer-cta-buttons">
        <a href="https://apps.apple.com/us/app/vectr42/id6775978008" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
          <button className="footer-app-btn">
            <img src={appleIcon} alt="Apple" className="footer-store-icon" />
            <div className="footer-btn-text">
              <div className="footer-btn-label">Download on the</div>
              <div className="footer-btn-name">App Store</div>
            </div>
          </button>
        </a>
        <button className="footer-app-btn">
          <img src={googlePlayIcon} alt="Google Play" className="footer-store-icon" />
          <div className="footer-btn-text">
            <div className="footer-btn-label">GET IT ON</div>
            <div className="footer-btn-name">Google Play</div>
          </div>
        </button>
      </div>
    </section>
  );
};

export default Footer;
